import * as React from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import Collapse from '../../../../components/collapse/Collapse';
import HeaderPNRTrackerContainer from '../../../flightDetailsPage/components/headerPNRTracker/HeaderPNRTrackerContainer';
import PaymentDetail from '../../../flightDetailsPage/components/paymentDetail/PaymentDetail';
import FlightDetail from '../../../flightDetailsPage/components/flightDetail/FlightDetail';
import InformationCancel from '../informationCancel/InformationCancel';

const propTypes = {
  afterCancel: PropTypes.any,
  data: PropTypes.any,
  cancelData: PropTypes.any,
  azulNumber: PropTypes.any
};

class CancelPnrDetail extends React.Component {

  componentDidMount(){
    window.scroll(0,400)
  }
  
  render() {    
    return (
      <div className="DetailPNRContainer">
        <div className="body-min-height bg-white">
          <HeaderPNRTrackerContainer
            hideCancelButton={true}
            hideBackButton={this.props.afterCancel}
            hideAdicionalButton={true}
            pnrItem={this.props.data}
            hideChangeTrip={true}
          />
          <div className="padding-eight-top-24">
            <Collapse
              name="collapseDetail"
              label={i18n.translate('label.detailTrip')}
              collapsed={true}>
              <FlightDetail data={this.props.data} />
            </Collapse>
          </div>
          <div className="margin-eight-top-48">
            <Collapse
              collapsed={true}
              name="collapsePaymentDetail"
              label={i18n.translate('label.paymentDetail')}>
              <PaymentDetail data={this.props.data} />
            </Collapse>
          </div>
          <div className="margin-eight-top-48">
            <Collapse
              name="collapseInfoCancel"
              label={i18n.translate('label.infoCancel')}
            >
              <InformationCancel
                cancelSimulateModel={this.props.cancelData}
                azulNumber={this.props.azulNumber} />
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
}

CancelPnrDetail.propTypes = propTypes;

export default CancelPnrDetail;



// WEBPACK FOOTER //
// ./src/page/cancelPnr/components/cancelPnrDetail/CancelPnrDetails.jsx